import { render, staticRenderFns } from "./bill-type.vue?vue&type=template&id=3216c920"
import script from "./bill-type.vue?vue&type=script&lang=js"
export * from "./bill-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports